import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import React from 'react';
import Filmmusic from 'src/assets/images/Filmmusic.svg';

const Wrapper = styled.div`
  max-width: 12rem;
  margin: 0 auto 0.5rem auto;
  position: relative;
  z-index: 0;
  text-align: center;
`;
const MediaButtonA = styled.a<{ color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  background-color: ${colors.white};
  border: 1px solid ${(prop) => prop.color};
  border-radius: 7px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  padding: 8px 13px;
  max-width: 12rem;
`;

interface Iprops {
  audioFilename: string;
  color: string;
}

const TmarkMedia: React.FC<Iprops> = ({ audioFilename, color }) => {
  return (
    <Wrapper>
      {audioFilename && (
        <MediaButtonA color={color} href={audioFilename} target="_blank">
          <img src={Filmmusic} alt={'影音檔案'} />
          影音檔案
        </MediaButtonA>
      )}
    </Wrapper>
  );
};

export default TmarkMedia;
